import React from "react"
import styles from "./styles.scss"
import CaseStudy from "components/CaseStudy"
import CaseStudyProvider from "components/CaseStudyProvider"
import wireframes from "images/wireframes.png"
import wireframesDone from "images/wireframes-done.png"
import colors from "images/esen-colors.png"
import fonts from "images/esen-fonts.png"

class ESENCaseStudy extends React.Component {
  render() {
    return (
      <CaseStudyProvider
        render={caseStudies => {
          const caseStudy = caseStudies.find(x => x.company === "ESEN eSports")
          return (
            <CaseStudy
              caseStudy={caseStudy}
              renderSummary={() => (
                <React.Fragment>
                  <p>
                    Det börsnoterade företaget ESEN eSports kom till oss med
                    idén att skapa en egen turneringsplattform. De ville kunna
                    styra innehållet kring sina turneringar och sändningar och
                    på så sätt ge ett mervärde till spelare, tittare och
                    samarbetspartners.
                  </p>

                  <p>
                    Vi utvecklade denna plattform som framöver kommer att utgöra
                    en central del för ESEN där de anordnar egna turneringar som
                    nordens största CS:GO turnering “King of Nordic” som även
                    streamas live varje vecka. Systemet fungerar också som en
                    plattform för ESEN’s partners som håller sina turneringar på
                    just denna plattform. SESF’s VM-kval i League of Legends,
                    CS:GO och Tekken 7 har alla spelats på plattformen.
                  </p>
                  <p>
                    Plattformen är i bruk och kan hittas på{" "}
                    <a
                      href="https://kingofnordic.com/"
                      target="_blank"
                      title="Gå till https://kingofnordic.com/"
                      rel="noopener noreferrer"
                    >
                      kingofnordic.com
                    </a>
                    .
                  </p>
                </React.Fragment>
              )}
              renderProblem={() => (
                <React.Fragment>
                  <p>
                    ESEN anordnade sina turneringar på diverse externa
                    turneringsplattformar med begränsad funktionalitet. De hade
                    varken möjlighet att påverka hur allt innehåll presenterades
                    eller tillåta sina sponsorer och partners att få den
                    synlighet som önskades. Man ville utöka aktiviteter och
                    skapa mervärde för tittarna och spelarna genom att samla
                    statistik och information kring sina turneringar på en plats
                    istället för att skjuta ut det till olika plattformar.
                  </p>
                  <p>
                    ESEN ville även kunna erbjuda föreningar möjligheten att
                    organisera turneringar på plattformen där en av de
                    viktigaste funktionerna var att koppla ihop registreringarna
                    med deras medlemssystem så att föreningarna kunde rekrytera
                    nya medlemmar genom att driva olika turneringar.
                  </p>
                </React.Fragment>
              )}
              renderDesign={() => (
                <React.Fragment>
                  <p>
                    Första steget blev att tillsammans ta fram en
                    kravspecifikation på en så kallad MVP (Minimum Viable
                    Product) baserat på deras vision om plattformen. När
                    kravspecifikationen var på plats så påbörjade vi arbetet med
                    att ta fram styrdokument i form av SAD (Software
                    Architecture Document). En SAD är till för att ge en
                    arkitekturell överblick av system. Genom flera olika
                    modelleringar avbildas olika delar och synvinklar av
                    systemet.
                  </p>
                  <p>
                    I nästa steg påbörjade våra designers arbetet med att ta
                    fram en grunddesign för plattformen med hjälp av verktyget
                    AdobeXD, som är en programvara för att ta fram interaktiva
                    prototyper. I takt med att designen växte fram påbörjades
                    även utvecklingsarbetet som i början främst bestod av back
                    end-arbete.
                  </p>
                  <img
                    className={styles.wireframesImage}
                    src={wireframes}
                    alt="Wireframes design på turnerningsplattformen innan produktutveckling påbörjades."
                  />
                  <p>
                    Eftersom att turneringsplattformen har många interaktioner
                    och funktioner var det extra viktigt att tidigt skapa
                    prototyper som fokuserar på sidans användarvänlighet och
                    flöde.
                  </p>
                  <img
                    className={styles.wireframesImage}
                    src={wireframesDone}
                    alt="Färdig produkt av turnerningsplattformen efter design och utveckling."
                  />
                  <p>
                    Efter att ha arbetat på användarflödet och de olika
                    interaktiva processerna började vi diskutera de grafiska
                    elementen på plattformen.
                  </p>
                  <h3>Färger</h3>
                  <div>
                    <img
                      className={styles.colorsImage}
                      src={colors}
                      alt="Turnerningsplattformens primära och sekundära färger."
                    />
                  </div>
                  <h3>Typsnitt - Roboto</h3>
                  <div className={styles.fontContainer}>
                    <p className={styles.text}>
                      Eftersom att ESEN är en gamingplattform var det viktigt
                      att alla aspekter av designen skulle vara snygga, men
                      framför allt moderna. Därför föll valet på Roboto som är
                      ett enkelt typsnitt med öppna kurvor och geometriska
                      former.
                    </p>
                    <div className={styles.imageContainer}>
                      <img
                        className={styles.fontImage}
                        src={fonts}
                        alt="Olika vikter och typer av turnerningsplattformens typsnitt, Roboto."
                      />
                    </div>
                  </div>
                </React.Fragment>
              )}
              renderTechnology={() => (
                <React.Fragment>
                  <h3>Front end / Back end</h3>
                  <p>
                    När designen blivit framtagen och godkänd av ESEN påbörjades
                    front-end-arbetet med att "snygga" till plattformen. Detta
                    gjordes med hjälp av HTML5, SASS och JavaScript.
                  </p>
                  <p>
                    Plattformen är skriven med Ruby on Rails i grunden som är
                    ett webbramverk som baseras på det objekt-orienterade
                    programmeringsspråket Ruby.
                  </p>
                  <h3>Databaser</h3>
                  <p>
                    Något som är väldigt viktigt att tänka på när man utvecklar
                    en stor och komplex turneringsplattform är prestanda och
                    skalbarhet, så att man i framtiden lätt kan utveckla nya
                    funktioner. Det är viktigt att i databasen (PostgreSQL)
                    indexera rätt rader - de som anropas ofta. Indexering är i
                    stort sett att man skapar ett register, såsom återfinns i
                    många böcker. Förenklat kan sägas att istället för att
                    bläddra genom hela boken efter det man söker, kollar man i
                    registret och slår upp rätt sida. Genom att indexera rätt
                    rader kan man förbättra prestandan på plattformen avsevärt.
                  </p>
                  <h3>Twitch API</h3>
                  <p>
                    Eftersom ESEN har sina sändningar via Twitch.tv har vi
                    implementerat en koppling mot Twitch's API för att
                    automatiskt hämta in deras tidigare sändningar samt gjort en
                    Webhook-koppling som gör att vi kan presentera ESEN's
                    sändningar via plattformen när de startar.
                  </p>
                  <h3>Turneringsdelen</h3>
                  <p>
                    Plattformen har även en turneringsdel där ESEN och deras
                    samarbetsorganisationer kan anordna turneringar inom esport.
                    Vi har byggt tre olika turneringsformer: Single Elimination,
                    Double Elimination och King of the Hill. Turneringarna är
                    byggda så att lagen automatiskt flyttas fram med hjälp av
                    olika algoritmer för att hamna "rätt", t.ex. när ett
                    resultat för en match har kommit in.
                  </p>
                  <p>
                    För att underlätta för användare har även "live in-app
                    notifications" implementerats som underrättar användaren när
                    något händer på plattformen.
                  </p>
                </React.Fragment>
              )}
            />
          )
        }}
      />
    )
  }
}

export default ESENCaseStudy



// WEBPACK FOOTER //
// ./src/pages/CaseStudies/ESENCaseStudy/index.jsx